/** localStorage cifrada con AES (crypto-js): guardar, leer y borrar los valores encriptados con VITE_SECRET. */
import CryptoJS from "crypto-js";

const SECRET_KEY = import.meta.env.VITE_SECRET;

const INNERWORK_KEYS = [
  "loggedUserInnerwork",
  "lastModule",
  "innerwork-dark-mode",
  "innerwork-menu",
  "innerwork-modules",
  "innerwork-active-sucursal",
];

const encryptData = (data: unknown): string => {
  return CryptoJS.AES.encrypt(JSON.stringify(data), SECRET_KEY).toString();
};

const decryptData = (encryptedData: string): unknown => {
  try {
    const bytes = CryptoJS.AES.decrypt(encryptedData, SECRET_KEY);
    const decryptedData = bytes.toString(CryptoJS.enc.Utf8);
    return JSON.parse(decryptedData);
  } catch {
    return null;
  }
};

export const saveInStorage = (key: string, data: unknown): void => {
  localStorage.setItem(key, encryptData(data));
};

export const getFromStorage = async <T = unknown>(key: string): Promise<T | null> => {
  const encrypted = localStorage.getItem(key);
  if (!encrypted) return null;
  return decryptData(encrypted) as T;
};

export const removeFromStorage = (key: string): void => {
  localStorage.removeItem(key);
};

/** Limpia todas las claves propias de Innerwork. */
export const clearStorage = (): void => {
  INNERWORK_KEYS.forEach((key) => localStorage.removeItem(key));
};
